import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as v, S as f } from "./icons.types-0722eef5.js";
function p({ title: e, titleId: c, size: r, width: n, height: o, extended: a = !1, ...h }) {
  const i = a ? v : f, s = r ? i[r] : n || i[a ? "s" : "l"], t = r ? i[r] : o || i[a ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: s,
      height: t,
      "aria-labelledby": c,
      ...h,
      children: [
        e ? /* @__PURE__ */ l("title", { id: c, children: e }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Camera_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M46.498 9a2.25 2.25 0 0 1 2.161 1.625l1.788 6.186c.032.127.273.296.662.296h16.286c2.483 0 4.605 1.97 4.605 4.437v37.02C72 61.029 69.878 63 67.395 63H4.605C2.122 63 0 61.03 0 58.564v-37.02c0-2.466 2.122-4.437 4.605-4.437h16.384c.39 0 .63-.169.684-.38l1.766-6.102A2.25 2.25 0 0 1 25.6 9h20.898ZM36.75 22.5A15.711 15.711 0 0 0 21 38.25C21 46.979 28.021 54 36.75 54S52.5 46.979 52.5 38.25 45.479 22.5 36.75 22.5Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Camera_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as Camera
};
